import { Navigate } from "react-router";
import { useUserPermissions } from "@/hooks/use-user-permissions";
import { ErrorState } from "@/components/ui/states";
import type { ScreenType } from "@/types/user-profile";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredScreen: ScreenType;
}

export function ProtectedRoute({ children, requiredScreen }: ProtectedRouteProps) {
  const { screens, agenciaId, isLoading, isError, refetch } = useUserPermissions();

  // Enquanto carrega as permissões, não renderiza nada (evita flash)
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-muted-foreground">Carregando...</div>
      </div>
    );
  }

  if (isError) {
    return (
      <ErrorState
        title="Não foi possível carregar suas permissões"
        description="Nenhuma tela é liberada sem elas. Tente de novo em instantes."
        onRetry={refetch}
      />
    );
  }

  // Verifica se o usuário tem permissão para acessar esta tela
  const hasPermission = screens.includes(requiredScreen);

  // Agency users only have the agency portal: any other screen sends them there.
  if (!hasPermission && agenciaId) {
    return <Navigate to="/agencia/avaliacoes" replace />;
  }

  if (!hasPermission) {
    // Redireciona para 404 se não tiver permissão
    return <Navigate to="/404" replace />;
  }

  return <>{children}</>;
}

